// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 24 24%27 stroke=%27%2364748b%27%3E%3Cpath stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M19 9l-7 7-7-7%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.app-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f2f4f8, #e4e9f2);
  padding: 24px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  direction: rtl;
}

.card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.home-card {
  max-width: 960px;
}

.card-header h1 {
  margin: 0;
  font-size: 28px;
  color: #1e293b;
}

.card-header p {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 15px;
}

.school-line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.details-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.actions-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form label {
  font-weight: 600;
  color: #0f172a;
}

.form input {
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #cbd5f5;
  background: #f8fafc;
  font-size: 15px;
  color: #0f172a;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.15);
}

.form button {
  margin-top: 8px;
  padding: 12px;
  border-radius: 10px;
  border: none;
  background: #2563eb;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.form button:hover:not(:disabled) {
  background: #1d4ed8;
  transform: translateY(-1px);
}

.form button:disabled {
  background: #94a3b8;
  cursor: not-allowed;
}

.status-message {
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-message.success {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #34d399;
}

.status-message.error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.status-message.loading {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}

.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.panel {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.panel-header h2 {
  margin: 0;
  color: #0f172a;
}

.panel-header span {
  color: #475569;
  font-size: 14px;
}

.actions-bar {
  display: flex;
  justify-content: flex-end;
}

.actions-bar button {
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.actions-bar .secondary {
  background: #e2e8f0;
  color: #0f172a;
}

.school-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.school-list li {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.school-list li.active {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.school-name {
  font-weight: 600;
  color: #0f172a;
}

.school-meta {
  color: #475569;
  margin-top: 4px;
  font-size: 14px;
}

.school-list .empty {
  text-align: center;
  color: #94a3b8;
  font-weight: 500;
}

.empty-panel {
  padding: 16px;
  border-radius: 12px;
  border: 1px dashed #cbd5f5;
  background: #fff;
  text-align: center;
  color: #94a3b8;
}

/* Filters and Sorting Bar */
.filters-container {
  display: flex;
  justify-content: center; /* Center content */
  align-items: center;
  gap: 40px;
  margin-top: 16px;
  padding: 12px 20px;
  background-color: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
  /* Removed width: 100% to avoid overflow with padding */
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-group label {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
}

.search-wrapper {
  min-width: 200px;
  width: 100%;
  max-width: 320px; /* Tighter search box */
}

.filters-actions-wrapper {
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.filter-input, .filter-select {
  width: 100%;
  padding: 4px 14px; /* Further reduced padding */
  border-radius: 10px;
  border: 1px solid #cbd5f5;
  background: #ffffff;
  font-size: 14px;
  color: #0f172a;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  height: 30px; /* Further reduced height */
}

.filter-input:focus, .filter-select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.filter-select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: left 10px center; /* Slightly adjusted icon position */
  background-size: 14px; /* Slightly smaller icon */
  padding-left: 36px;
}

/* Tabs Styling */
.tabs-container {
  display: flex;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
  width: 100%;
  padding-bottom: 12px;
  margin-bottom: 8px;
  margin-top: 8px; /* Added top margin for separation */
}

.tab-button {
  padding: 10px 24px;
  border-radius: 24px;
  border: none;
  background-color: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.2s ease;
}

.tab-button:hover {
  background-color: #e2e8f0;
  color: #1e293b;
}

.tab-button.active {
  background-color: #2563eb;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
}

.users-panel-header {
  flex-direction: column;
  align-items: flex-start;
  gap: 24px; /* Increased gap from 16px */
}

.users-header-row {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.users-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

/* صورة المستخدم الدائرية */
.user-avatar-circle {
  width: 32px; /* Smaller avatar */
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid #e0e0e0;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-avatar-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.users-list li {
  padding: 14px 18px; /* Reduced padding */
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  margin-bottom: 12px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.users-list li:hover {
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.08);
}

.user-name {
  font-weight: 600;
  color: #0f172a;
}

.user-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.user-meta {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  color: #475569;
  font-size: 14px;
}

.tag {
  padding: 4px 10px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #0f172a;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.tag.positive {
  background: #dcfce7;
  color: #15803d;
}

.tag.neutral {
  background: #fee2e2;
  color: #b91c1c;
}

.user-footer {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 13px;
  color: #64748b;
}

.user-actions {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
  margin-bottom: 4px;
}

.section-label span {
  white-space: nowrap;
  min-width: 80px;
}

.user-actions .date-input {
  padding: 4px 8px; /* Even slimmer */
  border-radius: 6px;
  border: 1px solid #cbd5f5;
  background: #f8fafc;
  font-size: 13px;
  height: 28px; /* Slightly smaller height */
  width: 120px; /* Fixed width for dates */
}

.user-actions .date-time-row, .user-actions .nfc-row {
  display: flex;
  align-items: center;
  gap: 12px; /* Tightened gap */
  flex-wrap: wrap;
}

.nfc-row label, .date-time-row label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
}

.user-actions .secondary {
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid #cbd5f5;
  background: #f1f5f9;
  color: #475569;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  height: 30px; /* Match desired height */
  transition: all 0.2s ease;
  white-space: nowrap;
}

.user-actions .secondary:hover:not(:disabled) {
  background: #e2e8f0;
  color: #1e293b;
}

.user-actions .secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.clock-time-picker {
  width: 90px; /* Fixed, much narrower width */
}

.clock-time-picker .react-time-picker__wrapper {
  border: 1px solid #cbd5f5 !important;
  border-radius: 6px !important;
  height: 28px !important;
  background: #f8fafc !important;
  padding: 0 4px !important;
  display: flex !important;
  justify-content: center !important;
}

.clock-time-picker .react-time-picker__inputGroup {
  direction: ltr;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0px !important;
  font-size: 14px !important;
  flex-grow: 1;
}

.clock-time-picker .react-time-picker__inputGroup__input {
  text-align: center;
  color: #0f172a !important;
  padding: 0 !important;
  width: 20px !important; /* Slightly wider for better centering */
  min-width: unset !important;
  border: none !important;
  background: transparent !important;
}

.clock-time-picker .react-time-picker__inputGroup__divider {
  padding: 0 1px !important;
  font-weight: bold;
}

/* Hide clock and clear icons to reclaim space */
.clock-time-picker .react-time-picker__button {
  display: none !important;
}

.user-actions .date-time-row label span {
  min-width: unset !important; /* Allow label to be narrow */
}

.user-actions .date-time-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.user-actions .nfc-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}

.user-actions .primary {
  padding: 12px 24px;
  border-radius: 10px;
  border: none;
  background: #2563eb;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%; /* Better prominence */
  margin-top: 8px;
}

.user-actions .primary:hover:not(:disabled) {
  background: #1d4ed8;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.user-actions .primary:disabled {
  background: #94a3b8;
  cursor: not-allowed;
}

.user-actions .secondary {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #0f172a;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.user-actions .secondary:hover {
  background: #f1f5f9;
}

.primary.outline {
  background: transparent;
  color: #2563eb;
  border: 1px solid #2563eb;
}

.primary.outline:hover:not(:disabled) {
  background: rgba(37, 99, 235, 0.08);
}

.icon-button {
  border: none;
  background: #e0f2fe;
  color: #0f172a;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
}

.icon-button:hover:not(:disabled) {
  background: #bae6fd;
  transform: translateY(-1px);
}

.icon-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.progress-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}

.header-content {
  flex: 1 1;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 24px;
}

.grid-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #f8fafc;
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.sort-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sort-group span {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

.sort-select {
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
  font-size: 14px;
  color: #0f172a;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
}

.sort-select:hover {
  border-color: #3b82f6;
}

.sort-order-btn {
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  color: #3b82f6;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sort-order-btn:hover {
  background: #eff6ff;
  border-color: #3b82f6;
}

.progress-header h2 {
  margin: 0;
  color: #0f172a;
}

.progress-header p {
  margin: 4px 0 0;
  color: #475569;
}

.progress-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}

.progress-card {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.progress-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.progress-card__header h3 {
  margin: 0;
  font-size: 18px;
  color: #0f172a;
}

.progress-card__header p {
  margin: 4px 0 0;
  color: #475569;
  font-size: 14px;
}

.progress-chart {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.progress-chart__label {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  color: #0f172a;
}

.progress-chart__label strong {
  font-size: 20px;
  color: #2563eb;
}

.progress-chart__bar {
  width: 100%;
  height: 12px;
  border-radius: 999px;
  background: linear-gradient(90deg, #e2e8f0, #f8fafc);
  overflow: hidden;
  position: relative;
}

.progress-chart__value {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border-radius: 999px;
  background: linear-gradient(90deg, #10b981, #3b82f6);
  transition: width 0.3s ease;
}

.progress-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  text-align: center;
}

.progress-details div {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
  background: #f8fafc;
}

.progress-details strong {
  display: block;
  font-size: 20px;
  color: #0f172a;
}

.progress-details span {
  font-size: 13px;
  color: #64748b;
}

/* App Notifications */
.app-notification {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 999px;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 9999;
  animation: slideUp 0.3s ease;
}

.app-notification.success {
  background: #10b981;
}

.app-notification.error {
  background: #ef4444;
}

@keyframes slideUp {
  from {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB,EAAE,mBAAmB;EAC5C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB,EAAE,4BAA4B;EAC/C,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,wDAAwD;EACxD,YAAY,EAAE,2BAA2B;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAA6P;EAC7P,4BAA4B;EAC5B,qCAAqC,EAAE,oCAAoC;EAC3E,qBAAqB,EAAE,0BAA0B;EACjD,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,eAAe,EAAE,oCAAoC;AACvD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS,EAAE,4BAA4B;AACzC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,WAAW,EAAE,mBAAmB;EAChC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB,EAAE,oBAAoB;EACxC,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,iBAAiB;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY,EAAE,4BAA4B;EAC1C,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,kBAAkB;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY,EAAE,yBAAyB;EACvC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB,EAAE,wCAAwC;EAChE,2BAA2B;EAC3B,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B,EAAE,6BAA6B;AAC5D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,WAAW,EAAE,sBAAsB;EACnC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,oBAAoB;EACpB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mFAAmF;EACnF,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.app-layout {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #f2f4f8, #e4e9f2);\n  padding: 24px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  direction: rtl;\n}\n\n.card {\n  width: 100%;\n  max-width: 420px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.home-card {\n  max-width: 960px;\n}\n\n.card-header h1 {\n  margin: 0;\n  font-size: 28px;\n  color: #1e293b;\n}\n\n.card-header p {\n  margin: 8px 0 0;\n  color: #64748b;\n  font-size: 15px;\n}\n\n.school-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.details-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.actions-group {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.form label {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.form input {\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid #cbd5f5;\n  background: #f8fafc;\n  font-size: 15px;\n  color: #0f172a;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.15);\n}\n\n.form button {\n  margin-top: 8px;\n  padding: 12px;\n  border-radius: 10px;\n  border: none;\n  background: #2563eb;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.form button:hover:not(:disabled) {\n  background: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.form button:disabled {\n  background: #94a3b8;\n  cursor: not-allowed;\n}\n\n.status-message {\n  padding: 12px 14px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-message.success {\n  background: #ecfdf5;\n  color: #047857;\n  border: 1px solid #34d399;\n}\n\n.status-message.error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n\n.status-message.loading {\n  background: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #bfdbfe;\n}\n\n.content-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n.panel {\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 20px;\n  background: #f9fafb;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.panel-header h2 {\n  margin: 0;\n  color: #0f172a;\n}\n\n.panel-header span {\n  color: #475569;\n  font-size: 14px;\n}\n\n.actions-bar {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.actions-bar button {\n  padding: 10px 16px;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.actions-bar .secondary {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.school-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.school-list li {\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.school-list li.active {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.school-name {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.school-meta {\n  color: #475569;\n  margin-top: 4px;\n  font-size: 14px;\n}\n\n.school-list .empty {\n  text-align: center;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.empty-panel {\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px dashed #cbd5f5;\n  background: #fff;\n  text-align: center;\n  color: #94a3b8;\n}\n\n/* Filters and Sorting Bar */\n.filters-container {\n  display: flex;\n  justify-content: center; /* Center content */\n  align-items: center;\n  gap: 40px;\n  margin-top: 16px;\n  padding: 12px 20px;\n  background-color: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  /* Removed width: 100% to avoid overflow with padding */\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.filter-group label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1e293b;\n  white-space: nowrap;\n}\n\n.search-wrapper {\n  min-width: 200px;\n  width: 100%;\n  max-width: 320px; /* Tighter search box */\n}\n\n.filters-actions-wrapper {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.filter-input, .filter-select {\n  width: 100%;\n  padding: 4px 14px; /* Further reduced padding */\n  border-radius: 10px;\n  border: 1px solid #cbd5f5;\n  background: #ffffff;\n  font-size: 14px;\n  color: #0f172a;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  height: 30px; /* Further reduced height */\n}\n\n.filter-input:focus, .filter-select:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.filter-select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: left 10px center; /* Slightly adjusted icon position */\n  background-size: 14px; /* Slightly smaller icon */\n  padding-left: 36px;\n}\n\n/* Tabs Styling */\n.tabs-container {\n  display: flex;\n  gap: 12px;\n  border-bottom: 1px solid #e2e8f0;\n  width: 100%;\n  padding-bottom: 12px;\n  margin-bottom: 8px;\n  margin-top: 8px; /* Added top margin for separation */\n}\n\n.tab-button {\n  padding: 10px 24px;\n  border-radius: 24px;\n  border: none;\n  background-color: #f1f5f9;\n  color: #64748b;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 15px;\n  transition: all 0.2s ease;\n}\n\n.tab-button:hover {\n  background-color: #e2e8f0;\n  color: #1e293b;\n}\n\n.tab-button.active {\n  background-color: #2563eb;\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);\n}\n\n.users-panel-header {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px; /* Increased gap from 16px */\n}\n\n.users-header-row {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.users-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* صورة المستخدم الدائرية */\n.user-avatar-circle {\n  width: 32px; /* Smaller avatar */\n  height: 32px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  border: 1px solid #e0e0e0;\n  background: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user-avatar-circle img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.users-list li {\n  padding: 14px 18px; /* Reduced padding */\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  margin-bottom: 12px;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.users-list li:hover {\n  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.08);\n}\n\n.user-name {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.user-name-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.user-meta {\n  margin-top: 6px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  color: #475569;\n  font-size: 14px;\n}\n\n.tag {\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  color: #0f172a;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.tag.positive {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.tag.neutral {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.user-footer {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.user-actions {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f1f5f9;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.section-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 700;\n  color: #1e293b;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.section-label span {\n  white-space: nowrap;\n  min-width: 80px;\n}\n\n.user-actions .date-input {\n  padding: 4px 8px; /* Even slimmer */\n  border-radius: 6px;\n  border: 1px solid #cbd5f5;\n  background: #f8fafc;\n  font-size: 13px;\n  height: 28px; /* Slightly smaller height */\n  width: 120px; /* Fixed width for dates */\n}\n\n.user-actions .date-time-row, .user-actions .nfc-row {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* Tightened gap */\n  flex-wrap: wrap;\n}\n\n.nfc-row label, .date-time-row label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0;\n}\n\n.user-actions .secondary {\n  padding: 4px 12px;\n  border-radius: 8px;\n  border: 1px solid #cbd5f5;\n  background: #f1f5f9;\n  color: #475569;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  height: 30px; /* Match desired height */\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.user-actions .secondary:hover:not(:disabled) {\n  background: #e2e8f0;\n  color: #1e293b;\n}\n\n.user-actions .secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.clock-time-picker {\n  width: 90px; /* Fixed, much narrower width */\n}\n\n.clock-time-picker .react-time-picker__wrapper {\n  border: 1px solid #cbd5f5 !important;\n  border-radius: 6px !important;\n  height: 28px !important;\n  background: #f8fafc !important;\n  padding: 0 4px !important;\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.clock-time-picker .react-time-picker__inputGroup {\n  direction: ltr;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0px !important;\n  font-size: 14px !important;\n  flex-grow: 1;\n}\n\n.clock-time-picker .react-time-picker__inputGroup__input {\n  text-align: center;\n  color: #0f172a !important;\n  padding: 0 !important;\n  width: 20px !important; /* Slightly wider for better centering */\n  min-width: unset !important;\n  border: none !important;\n  background: transparent !important;\n}\n\n.clock-time-picker .react-time-picker__inputGroup__divider {\n  padding: 0 1px !important;\n  font-weight: bold;\n}\n\n/* Hide clock and clear icons to reclaim space */\n.clock-time-picker .react-time-picker__button {\n  display: none !important;\n}\n\n.user-actions .date-time-row label span {\n  min-width: unset !important; /* Allow label to be narrow */\n}\n\n.user-actions .date-time-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.user-actions .nfc-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.user-actions .primary {\n  padding: 12px 24px;\n  border-radius: 10px;\n  border: none;\n  background: #2563eb;\n  color: #fff;\n  font-weight: 700;\n  font-size: 15px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%; /* Better prominence */\n  margin-top: 8px;\n}\n\n.user-actions .primary:hover:not(:disabled) {\n  background: #1d4ed8;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);\n}\n\n.user-actions .primary:disabled {\n  background: #94a3b8;\n  cursor: not-allowed;\n}\n\n.user-actions .secondary {\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #0f172a;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.user-actions .secondary:hover {\n  background: #f1f5f9;\n}\n\n.primary.outline {\n  background: transparent;\n  color: #2563eb;\n  border: 1px solid #2563eb;\n}\n\n.primary.outline:hover:not(:disabled) {\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.icon-button {\n  border: none;\n  background: #e0f2fe;\n  color: #0f172a;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.icon-button:hover:not(:disabled) {\n  background: #bae6fd;\n  transform: translateY(-1px);\n}\n\n.icon-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.progress-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.header-content {\n  flex: 1;\n}\n\n.progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.grid-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: #f8fafc;\n  padding: 8px 16px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.sort-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.sort-group span {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.sort-select {\n  height: 36px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  font-size: 14px;\n  color: #0f172a;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.sort-select:hover {\n  border-color: #3b82f6;\n}\n\n.sort-order-btn {\n  height: 36px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 18px;\n  font-weight: bold;\n  color: #3b82f6;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sort-order-btn:hover {\n  background: #eff6ff;\n  border-color: #3b82f6;\n}\n\n.progress-header h2 {\n  margin: 0;\n  color: #0f172a;\n}\n\n.progress-header p {\n  margin: 4px 0 0;\n  color: #475569;\n}\n\n.progress-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.progress-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 20px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n.progress-card__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.progress-card__header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #0f172a;\n}\n\n.progress-card__header p {\n  margin: 4px 0 0;\n  color: #475569;\n  font-size: 14px;\n}\n\n.progress-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.progress-chart__label {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  color: #0f172a;\n}\n\n.progress-chart__label strong {\n  font-size: 20px;\n  color: #2563eb;\n}\n\n.progress-chart__bar {\n  width: 100%;\n  height: 12px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #e2e8f0, #f8fafc);\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-chart__value {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #10b981, #3b82f6);\n  transition: width 0.3s ease;\n}\n\n.progress-details {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  text-align: center;\n}\n\n.progress-details div {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 12px;\n  background: #f8fafc;\n}\n\n.progress-details strong {\n  display: block;\n  font-size: 20px;\n  color: #0f172a;\n}\n\n.progress-details span {\n  font-size: 13px;\n  color: #64748b;\n}\n\n/* App Notifications */\n.app-notification {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 12px 24px;\n  border-radius: 999px;\n  color: #fff;\n  font-weight: 600;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  z-index: 9999;\n  animation: slideUp 0.3s ease;\n}\n\n.app-notification.success {\n  background: #10b981;\n}\n\n.app-notification.error {\n  background: #ef4444;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translate(-50%, 100%);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
